module.exports = __webpack_public_path__ + "files/04f66c748c0df0a80ae6e683d6c4fe57.png";